function normalizeAgreements(payload) {
  const agreements = payload?.agreements;

  if (Array.isArray(agreements)) {
    return agreements;
  }

  if (agreements && typeof agreements === 'object') {
    return Object.values(agreements);
  }

  return [];
}

export function mapAgreementsResponseToDto(payload) {
  return normalizeAgreements(payload).map((item, index) => ({
    id: String(item?.uid || item?.id || `agreement-${index}`),
    name: typeof item?.name === 'string' ? item.name : '',
  }));
}

export function buildAgreementsPayloadFromRows(rows) {
  return rows
    .map((row) => ({ name: String(row.name || '').trim() }))
    .filter((row) => row.name);
}

